import React from 'react';
import { workProcess } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const HowWeWorkSection = () => {
  const header = useScrollAnimation({ threshold: 0.15 });
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-[#041B1C] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-20 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#A5BF23]/10 text-[#A5BF23] px-4 py-1.5 rounded-full text-xs font-bold tracking-[0.2em] mb-4">OUR PROCESS</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F0F4F4] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Three Steps to Register Your Brand Name</h2>
          <p className="text-base text-[#A0B2B2] leading-relaxed">We strip the complexity out of brand name registration so you can focus on running your business.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 relative">
          <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-[1px] bg-gradient-to-r from-transparent via-[#A5BF23]/20 to-transparent" />
          {workProcess.map((step, index) => <ProcessStep key={step.id} step={step} index={index} />)}
        </div>
      </div>
    </section>
  );
};

const ProcessStep = ({ step, index }) => {
  const anim = useScrollAnimation({ threshold: 0.2 });
  return (
    <div ref={anim.ref} data-testid={`process-step-${step.id}`} className={`relative text-center scroll-fade-up scroll-delay-${index + 1} ${anim.isVisible ? 'scroll-visible' : ''}`}>
      <div className="w-20 h-20 rounded-2xl bg-[#093336]/60 border border-[#A5BF23]/20 flex items-center justify-center mx-auto mb-6 z-10 group transition-all duration-300 hover:border-[#A5BF23]/50 hover:bg-[#093336]">
        <span className="text-3xl font-bold text-[#A5BF23]" style={{ fontFamily: "'Outfit', sans-serif" }}>{step.step}</span>
      </div>
      <h3 className="text-xl font-bold tracking-tight text-[#F0F4F4] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>{step.title}</h3>
      <p className="text-sm text-[#A0B2B2] leading-relaxed max-w-xs mx-auto">{step.description}</p>
    </div>
  );
};

export default HowWeWorkSection;
